export const APPT_SERVICE_TYPE_MAP: Record<string, string> = {
  '13': 'Acupuncture',
  '239': 'Adult Mental Health Services',
  '14': 'Alexander Technique Therapy',
  '15': 'Aromatherapy',
  '536': 'Art therapy',
  '252': 'Assessment',
  '50': 'Audiology',
  '16': 'Biorhythm Services',
  '51': 'Blood Donation',
  '17': 'Bowen Therapy',
  '272': 'Breast Screen',
  '165': 'Cardiology',
  '215': 'Cardiothoracic Surgery',
  '283': 'Child And Adolescent',
  '18': 'Chinese Herbal Medicine',
  '52': 'Chiropractic',
  '288': 'Cholesterol',
  '166': 'Clinical Genetics',
  '301': 'Contraception Inform',
  '584': 'Cranio-sacral Therapy',
  '550': 'Dementia Care',
  '314': 'Dentistry',
  '315': 'Dentures',
  '168': 'Dermatology',
  '209': 'Diag. Radiology /Xray /CT /Fluoroscopy',
  '210': 'Diagnostic Ultrasound',
  '105': 'Drug and/or Alcohol Counselling',
  '117': 'Emergency Medical',
  '169': 'Endocrinology',
  '87': 'Endodontic',
  '491': 'Exercise Physiology',
  '54': 'Family Planning',
  '19': 'Feldenkrais',
  '170': 'Gastroenterology & Hepatology',
  '88': 'General Dental',
  '124': 'General Practice',
  '75': 'Genetic Counselling',
  '171': 'Geriatric Medicine',
  '185': 'Gynaecological Oncology',
  '481': 'Gynaecology',
  '581': 'Haematology',
  '55': 'Health Advocacy/Liaison Service',
  '76': 'Health Counselling',
  '104': 'Hearing Aids & Equipment',
  '479': 'Hepatology',
  '20': 'Homoeopathy',
  '360': 'Hospice Care',
  '21': 'Hydrotherapy',
  '22': 'Hypnotherapy',
  '368': 'Illness',
  '57': 'Immunization',
  '172': 'Immunology & Allergy',
  '173': 'Infectious Diseases',
  '371': 'Injury',
  '211': 'Magnetic Resonance Imaging (MRI)',
  '24': 'Magnetic Therapy',
  '25': 'Massage Therapy',
  '58': 'Maternal & Child Health',
  '175': 'Medical Oncology',
  '383': 'Medical Specialists',
  '537': 'Medication Reviews',
  '26': 'Meditation',
  '560': "Men's Health",
  '135': 'Mental Health Assess/Triage/Crisis Response',
  '137': 'Mental Health Information/Referral',
  '389': 'Multiple Sclerosis',
  '591': 'Music Therapy',
  '27': 'Myotherapy',
  '28': 'Naturopathy',
  '189': 'Neonatology & Perinatology',
  '176': 'Nephrology',
  '177': 'Neurology',
  '216': 'Neurosurgery',
  '212': 'Nuclear Medicine',
  '391': 'Nursing Home',
  '60': 'Nutrition',
  '186': 'Obstetrics & Gynaecology',
  '61': 'Occupational Therapy',
  '217': 'Ophthalmology',
  '62': 'Optometry',
  '90': 'Oral Surgery',
  '91': 'Orthodontic',
  '218': 'Orthopaedic Surgery',
  '63': 'Osteopathy',
  '219': 'Otolaryngology/Head & Neck Surgery',
  '400': 'Pain',
  '179': 'Palliative Medicine',
  '401': 'Pap Smear',
  '93': 'Periodontic',
  '64': 'Pharmacy',
  '407': 'Physical',
  '65': 'Physiotherapy',
  '220': 'Plastic & Reconstructive Surgery',
  '66': 'Podiatry',
  '409': 'Postnatal',
  '410': 'Pregnancy',
  '411': 'Pregnancy Tests',
  '413': 'Prescriptions',
  '416': 'Prostate',
  '585': 'Prosthetics & Orthotics',
  '94': 'Prosthodontic',
  '417': 'Psychiatric',
  '142': 'Psychology',
  '214': 'Radiation Oncology',
  '425': 'Referral',
  '29': 'Reflexology',
  '576': 'Rehabilitation',
  '30': 'Reiki',
  '31': 'Relaxation Therapy',
  '187': 'Reproductive Endocrinology/Infertility',
  '430': 'Respiratory',
  '182': 'Rheumatology',
  '67': 'Sexual Health',
  '32': 'Shiatsu',
  '183': 'Sleep Medicine',
  '580': 'Social Work',
  '68': 'Speech Pathology/Therapy',
  '447': 'Splinting',
  '451': 'STI',
  '452': 'Stillbirth',
  '453': 'Stomal Care',
  '454': 'Stroke',
  '455': 'Substance Abuse',
  '221': 'Surgery - General',
  '458': 'Teeth',
  '539': 'Telephone Help Line',
  '461': 'Therapy',
  '184': 'Thoracic Medicine',
  '188': 'Urogynaecology',
  '222': 'Urology',
  '223': 'Vascular Surgery',
  '629': 'Vision Equipment',
  '556': 'Walk-in Centre /Non-Emergency',
  '469': 'Weight',
  '33': 'Western Herbal Medicine',
  '473': 'Wound Management',
};
